"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A utiliser sur des composants (input, output, etc) qui peuvent avoir des valeurs dans le store.
 *
 */
exports.default = {
    props: ["sourceType", "sourceTarget", "sourceOnly", "defaultValue"],
    data: function data() {
        var model = this.$root.$data;
        var datas = this.getDataValue(model) || this.getSourceValue(model);
        return {
            selected: datas,
            value: datas === '' ? null : this.multiple !== undefined && this.multiple !== 'false' ? datas.split(',') : datas
        };
    },
    methods: {
        getSourceValue: function getSourceValue(model) {
            return this.sourceType ? model.dataStore[this.sourceType.toLowerCase() + "_" + this.sourceTarget] || "" : this.defaultValue || "";
        },
        getDataValue: function getDataValue(model) {
            var name = this.prefix || this.name;
            if (name && name.indexOf(".") !== -1) {
                var parts = name.split(".");
                if (!(parts[0] in model.data)) {
                    return null;
                }
                var v = model.data[parts[0]];
                if (!v) {
                    return null;
                }
                if (!(parts[1] in v) || parts[1] === "#") {
                    return null;
                }
                if (!v[+parts[1]]) {
                    return null;
                }
                return v[+parts[1]][parts[2]];
            }
            return !this.sourceOnly && model.data != null && name && model.data[name] !== null && model.data[name] !== undefined && model.data[name] !== "[]" ? model.data[name] : undefined;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Workflow/Mixins/SourceValue.ts
// module id = 24
// module chunks = 0